let env = require(`./env/${process.env.NODE_ENV}.js`);
module.exports = env;



// WEBPACK FOOTER //
// ./src/env.js